import React from 'react';

import { resolveArguments } from 'apps/promo/helpers/utils';
import clsx from 'clsx';

import styles from './Footer.module.css';
import { PromoDangerouslyHtml } from '../common/promo-dangerously-html/PromoDangerouslyHtml';

export default function License(props) {
    const copyClass = clsx(styles.copyRow, {
        [styles.copyRowBlack]: props.promoDarkPage,
    });

    return (
        <div className={copyClass}>
            <PromoDangerouslyHtml dangerouslyHtml={resolveArguments(props.licence, props.bank)} color={props.promoDarkPage ? 'gray40' : 'gray80'} tag="p" />
        </div>
    );
}
